/**
 * 공개 페이지의 <title>/<meta>. 같은 값을 두 군데가 쓴다:
 *  - 브라우저에서 화면이 바뀔 때(usePageMeta) — SPA라 라우트가 바뀌어도 문서 제목이 따라가게
 *  - 빌드 때 정적 HTML을 만들 때(scripts/prerender.ts) — 크롤러·카카오톡·슬랙은 JS를 안 돌리니
 *    HTML 안에 이미 들어 있어야 한다
 * 여기 없는 경로(로그인 뒤 화면 등)는 index.html의 기본값(noindex)을 그대로 쓴다.
 */
export type PageMeta = { title: string; description?: string; index: boolean };

const SITE = "Dabar Note";
const DEFAULT_DESCRIPTION = "설교 노트를 기록하고, 실천을 리마인드하고, 다시 찾아주는 개인 신앙 기록 서비스";

export const PUBLIC_PAGE_META: Record<string, PageMeta> = {
  "/": {
    title: `${SITE} — 설교 노트를 사진 한 장으로`,
    description: "손글씨 설교 노트를 찍으면 요약과 마인드맵, 이번 주 실천까지 정리해 주는 개인 신앙 기록 서비스",
    index: true,
  },
  "/terms": { title: `이용약관 · ${SITE}`, description: DEFAULT_DESCRIPTION, index: true },
  "/privacy": { title: `개인정보 처리방침 · ${SITE}`, description: DEFAULT_DESCRIPTION, index: true },
  "/scripture-copyright": { title: `성경 본문 저작권 안내 · ${SITE}`, description: DEFAULT_DESCRIPTION, index: true },
};

/** 빌드 때 정적 HTML을 만들 경로 목록. 이 밖의 경로는 app.html(SPA 껍데기)이 맡는다. */
export const PRERENDER_PATHS = Object.keys(PUBLIC_PAGE_META);

export const APP_TITLE = SITE;
